<template>
  <v-container class="user-form">
    <span class="fibl-headline">{{ $t('userLogin.headline') }}</span>
    <v-card 
      class="user__login-form"
      flat>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field
            class="above-align"
            name="email"
            :label="$t('userLogin.mail')"
            type="email"
            v-model="email"
            :rules="[rules.emailRules]"
          >
          </v-text-field>
            <a class="password-forgot" v-bind:href="reset_url">{{ $t('userLogin.passwordReset') }}</a>
          <v-text-field
            name="password"
            :label="$t('userLogin.password')"
            id="password"
            type="password"
            v-model="password"
            :rules="[rules.passwordRules]"
            v-on:keyup.enter="submit"
          >
          </v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-container>
          <v-row>
            <v-flex style="text-align:center;">
              <v-btn depressed class="button__primary" :disabled="!valid" @click="submit"
                >{{ $t('userLogin.login') }}</v-btn
              >
            </v-flex>
          </v-row>

          <v-row>
            <p class="register__text" >
              {{ $t('userLogin.text') }}
              <a v-bind:href="register_url">{{ $t('userLogin.register') }}</a>
            </p>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "UserLogin",


  computed: {
    ...mapState(["user", "message", "error"]),
  },

  mounted() {
    // store a reference to the component in each menu entry in order to be able to call methods on the component instance
    this.rules.emailRules.comp = this;
    this.rules.passwordRules.comp = this;
  },

  data() {
    return {
      register_url: "/user/register",
      reset_url: "/user/reset",
      valid: false,
      showSuccess: true,
      email: "",
      password: "",
      rules: {
        emailRules: [
        (v) => !!v || this.$i18n.t('userLogin.hint.mailRequired'),
        (v) => /.+@.+/.test(v) || this.$i18n.t('userLogin.hint.mailInvalid')
        ],
        passwordRules: [
        (v) => !!v || this.$i18n.t('userLogin.hint.passwordRequired'),
        (v) => v.match(/.{8,}/) || this.$i18n.t('userLogin.hint.charNumber'),
        (v) =>
          v.match(/[0-9]+/) ||
          this.$i18n.t('userLogin.hint.passwordRules'),
        (v) =>
          v.match(/[a-z]+/) ||
          this.$i18n.t('userLogin.hint.passwordRules'),
        (v) =>
          v.match(/[A-Z]+/) ||
          this.$i18n.t('userLogin.hint.passwordRules')
        ],
      },
    }
  },
  

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("login", {
          email: this.email,
          password: this.password,
        });
      }
    },
  },
};
</script>
